<script setup lang="ts">
import type { NavProps } from "~/types/nav.d"

const { folders = [], data } = defineProps<NavProps>()

const subjectsNotInFolders = computed(
  () => data.filter(
    subject => folders.every(folder => folder.id !== subject.parentLocationId),
  ),
)
</script>

<template>
  <ul class="no-scrollbar list-inside overflow-scroll pb-32 text-white after:pointer-events-none after:absolute after:bottom-0 after:left-0 after:z-20 after:h-[18%] after:w-full after:bg-gradient-to-t after:from-[--theme-darkest] after:to-transparent after:px-2 after:content-['']">
    <slot />
    <li
      v-for="folder in folders"
      :key="folder.id"
      class="hidden md:block"
    >
      <UNavListFolderItem
        :folder="folder"
        :page-type="pageType"
        :licence="licence"
        :data="data"
      />
    </li>
    <li
      v-for="subject in subjectsNotInFolders"
      :key="subject.id"
      class="hidden md:block"
    >
      <UNavListItem
        :item="subject"
        :page-type="pageType"
        :licence="licence"
      />
    </li>
  </ul>
</template>
